import { Flex, FormInput, Label } from '@grubhubprod/gh-cookbook-react';
import { Stack } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookTagWrapper } from 'src/components/CookbookTagWrapper/CookbookTagWrapper';
import { useGroupFieldsValidate } from 'src/components/oneCorp/features/MealCredit/common/formFields/Validation/useGroupFieldsValidate/useGroupFieldsValidate';
import { DAYS_SHORT } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export interface DayTagsProps {
  name: string;
  id: string;
  disabled?: boolean;
}

export function DayTags({ name, id, disabled }: DayTagsProps): JSX.Element {
  const { control } = useFormContext();
  const { error, validate } = useGroupFieldsValidate({
    name,
    errorMessage: 'Select at least one',
  });

  return (
    <FormInput inputSize="medium" blockWidth error={error}>
      <Label htmlFor={id}>Only on specific days of the week</Label>
      <Flex alignItems="center">
        {DAYS_SHORT.map((day, index, array) => {
          return (
            <Stack key={day} x="x-sm">
              <CookbookTagWrapper
                disabled={disabled}
                id={`${id}.${index}`}
                name={`${name}[${index}]`}
                control={control}
                label={day}
                value={day}
                aria-label={day}
                rules={{
                  validate: (value) => validate(value, array.length),
                }}
              />
            </Stack>
          );
        })}
      </Flex>
    </FormInput>
  );
}
